// CategoryContext.tsx

import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';
import { CategoryBarData } from 'shared/types/product/Category';
import { AnnouncementBarDataType } from 'components/commercetools-ui/organisms/announcement-bar/types';

interface ChildProps {
  children: ReactNode;
}

interface CategoryContextType {
  categoryBarData: CategoryBarData[] | null;
  setCategoryBarData: React.Dispatch<React.SetStateAction<CategoryBarData[] | null>>;
  announcementBarData: AnnouncementBarDataType;
  setAnnouncementBarData: React.Dispatch<React.SetStateAction<AnnouncementBarDataType>>;
}

const CategoryContext = createContext<CategoryContextType | undefined>(undefined);

export const CategoryBarProvider = ({ children }: ChildProps) => {
  const [categoryBarData, setCategoryBarData] = useState<CategoryBarData[] | null>(null);
  const [announcementBarData, setAnnouncementBarData] = useState<AnnouncementBarDataType>({
    isAnimate: false,
    render: false
  });

  const value = useMemo<CategoryContextType>(() => ({ categoryBarData, setCategoryBarData, announcementBarData, setAnnouncementBarData }), [categoryBarData, setCategoryBarData, announcementBarData, setAnnouncementBarData]);

  return (
    <CategoryContext.Provider
      value={value}
    >
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategoryBar = () => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategoryBar must be used within a CategoryBarProvider');
  }
  return context;
};
